import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { CaretDown } from "@phosphor-icons/react";
import React from "react";
import { Link } from "react-router-dom";

export const DatosCoberturaMedica = ({ person }) => {
  const { obraSocial, obraSocialTelefono, obraSocialCredencial } = person || {};

  if (obraSocial || obraSocialTelefono || obraSocialCredencial)
    return (
      <Accordion sx={{ marginTop: 2 }}>
        <AccordionSummary
          expandIcon={<CaretDown size={32} />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography fontWeight={700}>Cobertura médica</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ textAlign: "left" }}>
          <Typography fontWeight={700}>
            {obraSocial && (
              <Typography variant="h6">
                <b> Cobertura médica:</b> {obraSocial}
              </Typography>
            )}
            {obraSocialTelefono && (
              <Typography variant="h6">
                <b> Teléfono: </b>
                <Link to={`tel:${obraSocialTelefono}`}>
                  {obraSocialTelefono}
                </Link>
              </Typography>
            )}
            {obraSocialCredencial && (
              <Typography variant="saltoLinea">
                <b> N° de credencial: </b>
                {obraSocialCredencial}
              </Typography>
            )}
          </Typography>
        </AccordionDetails>
      </Accordion>
    );
};
